import {NODE_ENV} from "../utils/env"
import mixpanel from "../utils/mixpanel"
import businessService from "./business";
import userService from "./user";

class TrackingService {
    setup = (env: string) => {
        mixpanel.setup(env)
    }

    private trackEvent = async(name: string, data?: any) => {
      const [business, user] = await Promise.all([businessService.getCurrentBusiness(), userService.getCurrentUser()])

      const defaultData = {
        user_id: user.uuid,
        tenant_locale: user.language,
        tenant_id: user.businessId,
        tenant_subdomain: business.subdomain,
        tenant_public_name: business.businessName,
        source: "microsoft_teams"
      }

      mixpanel.trackEvent(name, {...defaultData, ...data})

    }

    startCreateRecognition = async (data?: object) => {
      await this.trackEvent("start_create_recognition", data)
    }

    recogniseButtonClick = async (data?: object) => {
      await this.trackEvent("launch_recognition", data)
    }

    closeButtonClick = async (data?: object) => {
      await this.trackEvent("recognition_cta_click", data)
    }

    login = async(data?: object) => {
      await this.trackEvent("login_user", data)
    }

}

const trackingService = new TrackingService()
trackingService.setup(NODE_ENV)

export default trackingService
